import StethoscopeBackground from 'components/common/StethoscopeBackground/StethoscopeBackground';
import Headline from 'components/UI/Typography/Headline';
import { Color } from 'modules/styles/colors';
import React from 'react';
import { MuiBox } from 'theme/material-ui';
import LoadingAnimation from './LoadingAnimation';
import { isFetchingDependenciesSelector } from 'store/global/selectors';
import { useSelector } from 'react-redux';

function Loading() {
  const isFetchingDependencies = useSelector(isFetchingDependenciesSelector);

  return (
    <StethoscopeBackground>
      <MuiBox display="flex" justifyContent="center" alignItems="center" height="100%">
        <LoadingAnimation />
        <Headline style={{ color: Color.foreColor }}>
          {isFetchingDependencies ? 'Loading your profile' : 'Loading'}
        </Headline>
      </MuiBox>
    </StethoscopeBackground>
  );
}

export default Loading;
